// extracted by mini-css-extract-plugin
export default {"footer":"UnitSettings_footer__yfO69","buttonsAction":"UnitSettings_buttonsAction__n9iQR","narrowInput":"UnitSettings_narrowInput__631Ge"};